import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { validateReset, resetPassword } from '../services/api';

const AuthHeader = () => (
  <div className="a-auth-header">
    <img src="/uploads/scala-logo.png" alt="SCALA" className="a-auth-header__logo" />
    <div className="a-auth-header__title">SCALA Performer Registry</div>
    <div className="a-auth-header__subtitle">Celebrating Songwriting</div>
  </div>
);

function ResetPasswordPage() {
  const { token } = useParams();
  const navigate  = useNavigate();

  const [valid, setValid]         = useState(null);
  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [showPw, setShowPw]       = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);

  useEffect(() => {
    validateReset(token)
      .then(() => setValid(true))
      .catch(() => setValid(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 8)  { setError('Password must be at least 8 characters.'); return; }

    setLoading(true); setError('');
    try {
      const res = await resetPassword(token, { password });
      if (res.data.requiresLogin) {
        navigate('/login', { state: { message: 'Password reset successful. Please log in.' } });
        return;
      }
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user',  JSON.stringify(res.data.user));
      navigate('/profile');
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (valid === null) return (
    <div className="a-auth-page">
      <div className="a-auth-card">
        <AuthHeader />
        <div className="a-auth-body" style={{ textAlign: 'center' }}>
          <p style={{ color: '#6b7280' }}>Validating reset link…</p>
        </div>
      </div>
    </div>
  );

  if (valid === false) return (
    <div className="a-auth-page">
      <div className="a-auth-card">
        <AuthHeader />
        <div className="a-auth-body">
          <div className="a-error" style={{ marginBottom: '1rem' }}>This reset link is invalid or has expired.</div>
          <a href="/forgot-password" className="a-btn a-btn--navy a-btn--full">Request a new link</a>
        </div>
      </div>
    </div>
  );

  return (
    <div className="a-auth-page">
      <div className="a-auth-card">
        <AuthHeader />
        <div className="a-auth-body">
          <h2>Set New Password</h2>
          {error && <div className="a-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="a-field">
              <label className="a-label">New Password</label>
              <div className="a-pw-wrap">
                <input className="a-input" type={showPw ? 'text' : 'password'} value={password}
                  onChange={e => setPassword(e.target.value)} required autoFocus placeholder="At least 8 characters" />
                <button type="button" className="a-pw-toggle" onClick={() => setShowPw(v => !v)}>
                  {showPw ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>
            <div className="a-field">
              <label className="a-label">Confirm Password</label>
              <div className="a-pw-wrap">
                <input className="a-input" type={showConfirm ? 'text' : 'password'} value={confirm}
                  onChange={e => setConfirm(e.target.value)} required />
                <button type="button" className="a-pw-toggle" onClick={() => setShowConfirm(v => !v)}>
                  {showConfirm ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>
            <button type="submit" className="a-btn a-btn--navy a-btn--full" disabled={loading}
              style={{ marginTop: '0.5rem' }}>
              {loading ? 'Saving…' : 'Set Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
